import React from 'react'
import NumberFormat from 'react-number-format'

const InputNumberCustom = ({
  onChange = values => {},
  prefix = '',
  inputRef = null,
  ...props
}) => {
  return (
    <NumberFormat
      getInputRef={inputRef}
      onValueChange={(values, sourceInfo) => {
        if (!sourceInfo.event) return
        onChange(values)
      }}
      fixedDecimalScale
      thousandSeparator="."
      decimalSeparator=","
      isNumericString
      decimalScale={2}
      prefix={prefix}
      {...props}
    />
  )
}

export default InputNumberCustom
